export default "__VITE_ASSET__BxMsnJQg__"